interface LoadMoreProps {
    displayedCount: number; // combien d'éléments déjà affichés
    totalCount: number;     // total réel renvoyé par ton backend
    loading: boolean;       // true pendant le chargement de la page suivante
    hasMore: boolean;       // true s'il reste des éléments à charger
    onLoadMore: () => void; // callback appelé au clic sur "Voir plus"
}


export default function LoadMore({ displayedCount, totalCount, loading, hasMore, onLoadMore, }: LoadMoreProps) {


    if (totalCount <= 0) return null;
    const percentage = Math.min(100, Math.round((displayedCount / totalCount) * 100));

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="mt-6 flex flex-col items-center gap-4">
            <div className="w-full max-w-xs">
                <div className="flex items-center justify-between text-xs mb-1.5">
                    <span className="text-foreground-500">
                        <span className="font-semibold text-foreground-800">{displayedCount}</span> affichées sur{' '}
                        <span className="font-semibold text-foreground-800">{totalCount}</span>
                    </span>
                    <span className="font-semibold text-primary-600">{percentage}%</span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
                    <div
                        className="h-full rounded-full bg-primary-500 transition-all duration-500"
                        style={{ width: `${percentage}%` }}
                    />
                </div>
            </div>
            {hasMore ? (
                <button
                    type="button"
                    onClick={onLoadMore}
                    disabled={loading}
                    className="flex items-center gap-2 px-6 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-wait"
                >
                    {loading ? (
                        <>
                            <i className="ri-loader-4-line text-base animate-spin"></i>
                            Chargement…
                        </>
                    ) : (
                        <>
                            Voir plus
                            <i className="ri-arrow-down-line text-base"></i>
                        </>
                    )}
                </button>
            ) : (
                <div className="flex flex-col items-center gap-2 text-center">
                    <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                        <i className="ri-sparkling-line text-accent-600 text-xl"></i>
                    </div>
                    <p className="text-sm font-semibold text-foreground-800">
                        Vous avez tout vu, bravo !
                    </p>
                    <p className="text-xs text-foreground-500">
                        Toutes les publications autour de toi sont affichées
                    </p>
                    <button
                        type="button"
                        onClick={scrollToTop}
                        className="mt-1 flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                        <i className="ri-arrow-up-line text-base"></i>
                        Retour en haut
                    </button>
                </div>
            )}
        </div>
    );
}